/*
 * @Author: qinmengyuan
 * @Date: 2024-08-19 18:24:19
 * @LastEditors: ttheitao
 * @LastEditTime: 2024-08-23 16:57:20
 * @FilePath: \onetab\src\router\index.js
 */
// src/router.js

import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HelloWorld.vue'),
  },

  {
    path: '/share',
    name: 'share',
    component: () => import('@/views/share-page/index.vue'),
    beforeEnter: (to, from, next) => {
      if (to.query.code) {
        next();
      } else {
        next('/');
      }
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
